import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Typography,
  Tooltip,
  IconButton,
  Box,
  Button,
  MenuItem,
  Divider,
  Dialog,
} from "@mui/material";
import Navbar from "../../Navbar";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

import Notify from "../../Notify";
import { getData, putData } from "../../../services/library";

// ICONOS
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckIcon from "@mui/icons-material/Check";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CommitIcon from "@mui/icons-material/Commit";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import BlockIcon from "@mui/icons-material/Block";
import EditIcon from "@mui/icons-material/Edit";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import EventBusyIcon from "@mui/icons-material/EventBusy";

// COMPONENTES
import Addvehiculos from "./Addvehiculos";
import Editarvehiculos from "./Editarvehiculos";
import MovimientoVehiculo from "./movimientosVehiculos/MovimientoVehiculo";
import ConfirmDialog from "../../Dialogs/ConfirmDialog";
import ConjuntoVehiculos from "./ConjuntoVehiculos";
import { logEventos } from "../../../services/services";
import VencimientosVehiculos from "./VencimientosVehiculos";

export default function Vehiculos() {
  const [vehiculos, setVehiculos] = useState(); //aca se almacenan los datos que me trae la api
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true); //Estado q mostrará o no la tabla (pantalla inicial) dnd estan los choferes
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de choferes
  const [movimientoVehiculo, setMovimientoVehiculo] = useState(false);
  const [conjuntos, setConjuntos] = useState(false);
  const [confirmarActivo, setConfirmarActivo] = useState(false);
  const [confirmarInactivo, setConfirmarInactivo] = useState(false);
  const [datosformulario, setDatosformulario] = useState({});
  const iconRemove = <RemoveCircleOutlineIcon sx={{ fontSize: 40 }} />;
  const iconCheck = <CheckIcon sx={{ fontSize: 40 }} />;
  const globalTheme = useTheme();
  const [notify, setNotify] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);

  const obtenervehiculos = () => {
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    getData("/vehiculos/new/activos", setVehiculos);
  };

  const obtenerinactivos = () => {
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    getData("/vehiculos/new/inactivos", setVehiculos);
  };

  useEffect(() => {
    obtenervehiculos();
  }, [tabla]);

  const handleClickNuevo = () => {
    setAlta(true);
    setTabla(false);
  };

  const mostrareditar = (datosDeLaLinea) => {
    setEditar(true);
    setTabla(false);
    setDatosformulario(datosDeLaLinea);
  };

  const VerMovimientoVehiculo = (datosDeLaLinea) => {
    setMovimientoVehiculo(true);
    setTabla(false);
    setDatosformulario(datosDeLaLinea);
  };

  const mostrarConjuntos = (datosDeLaLinea) => {
    setConjuntos(true);
    setTabla(false);
    setDatosformulario(datosDeLaLinea);
  };

  const handleClose = () => {
    setTabla(true);
    setConfirmarActivo(false);
    setConfirmarInactivo(false);
    confirmarActivo && obtenerinactivos();
    confirmarInactivo && obtenervehiculos();
  };

  const columns = useMemo(
    () => [
      { header: "Sisven", accessorKey: "id_sisven", size: 95 },
      { header: "Patente", accessorKey: "patente", size: 95 },
      { header: "Sucursal", accessorKey: "nombre_sucursal", size: 100 },
      { header: "Chofer", accessorKey: "chofer" },
      { header: "Uso", accessorKey: "usovehiculos", size: 100 },
      { header: "Dueño", accessorKey: "dueniovehiculo", size: 100 },
      { header: "Tipo", accessorKey: "tipovehiculos", size: 100 },
    ],
    []
  );

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default: "rgb(234, 239, 241)",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  // --------------------------------------------------------

  async function marcarInactivo(e) {
    putData(
      e,
      "/vehiculos/" + datosformulario.idvehiculo,
      {
        activo: 0,
      },
      setNotify,
      logEventos(
        "Marcar vehiculos como inactivo",
        "Vehiculos",
        "Vehiculos",
        localStorage.getItem("user")
      )
    );
  }

  async function marcarActivo(e) {
    putData(
      e,
      "/vehiculos/" + datosformulario.idvehiculo,
      {
        activo: 1,
      },
      setNotify,
      logEventos(
        "Marcar vehiculos como activo",
        "Vehiculos",
        "Vehiculos",
        localStorage.getItem("user")
      )
    );
  }

  const tableHeadCellProps = {
    align: "center",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
      "& .MuiSvgIcon-root": {
        color: "white", // color de los íconos
      },
    },
  };

  // *******************************************************

  const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState(null);

  // DIALOG PARA VER VENCIMIENTOS
  const [dialogVencimientos, setDialogVencimientos] = useState(false);

  // Abrir diálogo
  const handleOpenVencimientos = (row) => {
    setVehiculoSeleccionado(row);
    setDialogVencimientos(true);
  };

  // Cerrar diálogo
  const handleCloseVencimientos = () => {
    setDialogVencimientos(false);
  };

  // *******************************************************

  const abrirModalConfirmarActivo = (datosDeLaLinea) => {
    setConfirmarActivo(true);

    // console.log("datosDeLaLinea: ", datosDeLaLinea);
    setDatosformulario(datosDeLaLinea);
  };

  const abrirModalConfirmarInactivo = (datosDeLaLinea) => {
    setConfirmarInactivo(true);

    // console.log("datosDeLaLinea: ", datosDeLaLinea);
    setDatosformulario(datosDeLaLinea);
  };

  useEffect(() => {
    logEventos(
      "acceso al menú Vehiculos",
      "Tablas Referencias",
      "Vehiculos",
      localStorage.getItem("user")
    );
  }, []);

  // *******************************************************

  return (
    <>
      <Navbar />

      {vehiculos && tabla ? (
        <Container maxWidth="xl">
          <Box mt={2} boxShadow={3} mb={3}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                enableColumnResizing
                columns={columns}
                data={vehiculos}
                enableRowActions
                initialState={initialState}
                positionActionsColumn="last"
                muiTableHeadCellProps={tableHeadCellProps}
                localization={MRT_Localization_ES}
                muiTableBodyRowProps={({ table, row }) => {
                  // índice de la fila para alternar colores
                  const rowIndex = table
                    .getRowModel()
                    .rows.findIndex((r) => r.id === row.id);

                  // Paleta para los estados
                  const palettes = {
                    0: {
                      // INACTIVO
                      active: ["#fdeaea", "#fbdada"], // alternancia par/impar
                      hover: "#ffe2e2ff",
                    },
                    1: {
                      // ACTIVO
                      active: ["#eafef0", "#d8fbe2"], // alternancia par/impar
                      hover: "#d1f7d6",
                    },
                    default: {
                      // fallback (por si el estado no es 1 ni 0)
                      active: ["#ffffff", "#fafafa"],
                      hover: "#f3f4f6",
                    },
                  };

                  // Paleta según el estado (si no es 1 o 0, usa default)
                  const estado = Number.parseInt(row.original?.activo, 10);
                  const pal = palettes[estado] || palettes.default;

                  // color de fondo alternado con index
                  const bgColor = pal.active[rowIndex % 2];

                  return {
                    hover: false,
                    sx: {
                      backgroundColor: bgColor,
                      color: "black",
                      borderColor: "transparent",
                      transition:
                        "background-color 0.18s ease-in-out, transform 0.15s ease",
                      // línea inferior entre celdas
                      "& .MuiTableCell-root": {
                        borderBottom: "1px solid rgba(0,0,0,0.06)",
                      },
                      // hover personalizado
                      "&:hover": {
                        backgroundColor: pal.hover,
                        transform: "translateY(-1px)",
                      },
                    },
                  };
                }}
                enableColumnActions={false}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                enableDensityToggle={false}
                layoutMode="grid"
                renderTopToolbarCustomActions={() => (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddBoxTwoToneIcon />}
                      onClick={handleClickNuevo}
                    >
                      Nuevo Registro
                    </Button>

                    <Box display="flex" alignItems="center">
                      <LocalShippingIcon sx={{ fontSize: 26, mr: 1 }} />
                      <Typography fontSize={26}>Vehiculos</Typography>
                    </Box>
                  </>
                )}
                renderToolbarInternalActions={({ table }) => (
                  <>
                    {!hiddenmuestraactivos ? (
                      <Tooltip
                        arrow
                        placement="right"
                        title="Ver vehiculos activos"
                      >
                        <IconButton
                          color="success"
                          onClick={() => {
                            obtenervehiculos();
                          }}
                        >
                          <PersonIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {!hiddenmuestrainactivo ? (
                      <Tooltip
                        arrow
                        placement="right"
                        title="Ver vehiculos inactivos"
                      >
                        <IconButton
                          color="error"
                          onClick={() => {
                            obtenerinactivos();
                          }}
                        >
                          <PersonOffIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}

                    <MRT_FullScreenToggleButton table={table} />
                  </>
                )}
                renderRowActionMenuItems={({ closeMenu, row }) => {
                  // Estilo reutilizable por item
                  const itemSx = (theme, color) => ({
                    borderRadius: 1.2,
                    px: 1.2,
                    py: 0.6,
                    my: 0.4,
                    minWidth: 220,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    transition: "all 180ms ease",
                    "&:hover": {
                      backgroundColor:
                        color && theme.palette[color]
                          ? alpha(
                              theme.palette[color].main ?? theme.palette[color],
                              0.08
                            )
                          : alpha(theme.palette.primary.main, 0.06),
                      transform: "translateY(-2px)",
                    },
                  });

                  // ICONO
                  const iconBoxSx = (theme, color) => ({
                    minWidth: 36,
                    minHeight: 36,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    mr: 1.2,
                    backgroundColor:
                      color && theme.palette[color]
                        ? alpha(theme.palette[color].main, 0.12)
                        : alpha(theme.palette.primary.main, 0.08),
                  });

                  return (
                    <>
                      <MenuItem
                        onClick={() => {
                          handleOpenVencimientos(row.original);
                          closeMenu();
                        }}
                        sx={(theme) => itemSx(theme, "info")}
                      >
                        <Box sx={(theme) => iconBoxSx(theme, "info")}>
                          <EventBusyIcon color="info" />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "left",
                          }}
                        >
                          <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            Vencimientos
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: "text.secondary" }}
                          >
                            Ver vencimientos del vehículo
                          </Typography>
                        </Box>
                      </MenuItem>

                      <MenuItem
                        onClick={() => {
                          mostrareditar(row.original);
                          closeMenu();
                        }}
                        sx={(theme) => itemSx(theme, "primary")}
                      >
                        <Box sx={(theme) => iconBoxSx(theme, "primary")}>
                          <EditIcon color="primary" />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "left",
                          }}
                        >
                          <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            Editar Vehículo
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: "text.secondary" }}
                          >
                            Modificar datos y configuración
                          </Typography>
                        </Box>
                      </MenuItem>

                      <MenuItem
                        onClick={() => {
                          VerMovimientoVehiculo(row.original);
                          closeMenu();
                        }}
                        sx={(theme) => itemSx(theme, "success")}
                      >
                        <Box sx={(theme) => iconBoxSx(theme, "success")}>
                          <MoveUpIcon color="success" />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "left",
                          }}
                        >
                          <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            Movimientos del Vehículo
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ color: "text.secondary" }}
                          >
                            Historial y movimientos
                          </Typography>
                        </Box>
                      </MenuItem>

                      {row.original.id_tipo === 10 && (
                        <MenuItem
                          onClick={() => {
                            mostrarConjuntos(row.original);
                            closeMenu();
                          }}
                          sx={(theme) => itemSx(theme, "secondary")}
                        >
                          <Box sx={(theme) => iconBoxSx(theme, "secondary")}>
                            <CommitIcon color="secondary" />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              textAlign: "left",
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 600 }}
                            >
                              Acoplar Vehículos
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{ color: "text.secondary" }}
                            >
                              Vincular con otro vehículo
                            </Typography>
                          </Box>
                        </MenuItem>
                      )}

                      <Divider sx={{ my: 0.5 }} />

                      {row.original.activo === 0 ? (
                        <MenuItem
                          onClick={() => {
                            abrirModalConfirmarActivo(row.original);
                            closeMenu();
                          }}
                          sx={(theme) => itemSx(theme, "success")}
                        >
                          <Box sx={(theme) => iconBoxSx(theme, "success")}>
                            <CheckCircleOutlineIcon color="success" />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              textAlign: "left",
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 600 }}
                            >
                              Marcar como Activo
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{ color: "text.secondary" }}
                            >
                              Rehabilitar este vehículo
                            </Typography>
                          </Box>
                        </MenuItem>
                      ) : (
                        <MenuItem
                          onClick={() => {
                            abrirModalConfirmarInactivo(row.original);
                            closeMenu();
                          }}
                          sx={(theme) => itemSx(theme, "error")}
                        >
                          <Box sx={(theme) => iconBoxSx(theme, "error")}>
                            <BlockIcon color="error" />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              textAlign: "left",
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 600 }}
                            >
                              Marcar como Inactivo
                            </Typography>
                            <Typography
                              variant="caption"
                              sx={{ color: "text.secondary" }}
                            >
                              Deshabilitar este vehículo
                            </Typography>
                          </Box>
                        </MenuItem>
                      )}
                    </>
                  );
                }}
              />
            </ThemeProvider>
          </Box>
        </Container>
      ) : null}

      <Dialog
        fullWidth
        maxWidth={"md"}
        open={dialogVencimientos}
        onClose={handleCloseVencimientos}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
            overflow: "hidden",
            border: "2px solid #2B76A6",
            backgroundColor: "#ffffff",
            boxSizing: "border-box",
          },
        }}
      >
        <VencimientosVehiculos
          vehiculo={vehiculoSeleccionado}
          handleCloseVencimientos={handleCloseVencimientos} // Función para cerrar el diálogo
        />
      </Dialog>

      {confirmarActivo && (
        <ConfirmDialog
          title={"Activar vehiculo"}
          subtitle={"¿Desea cambiar el estado del vehiculo como activo?"}
          open={confirmarActivo}
          setOpen={setConfirmarActivo}
          notify={notify}
          setNotify={setNotify}
          btnText={"Aprobar"}
          guardar={marcarActivo}
          color={"#2ECC71"}
          icon={iconCheck}
          // actualizar={obtenerchoferes}
        />
      )}

      {confirmarInactivo && (
        <ConfirmDialog
          title={"Desactivar vehiculo"}
          subtitle={"¿Desea cambiar el estado del vehiculo como inactivo?"}
          open={confirmarInactivo}
          setOpen={setConfirmarInactivo}
          notify={notify}
          setNotify={setNotify}
          btnText={"Confirmar"}
          guardar={marcarInactivo}
          color={"#f53649"}
          icon={iconRemove}
          // actualizar={obtenerinactivos}
        />
      )}

      {alta ? <Addvehiculos alta={setAlta} tabla={setTabla} /> : null}

      {editar ? (
        <Editarvehiculos
          editar={setEditar}
          tabla={setTabla}
          datos={datosformulario}
        />
      ) : null}
      {conjuntos ? (
        <ConjuntoVehiculos
          conjuntos={setConjuntos}
          tabla={setTabla}
          datos={datosformulario}
        />
      ) : null}
      {movimientoVehiculo ? (
        <MovimientoVehiculo
          movimientoVehiculo={setMovimientoVehiculo}
          tabla={setTabla}
          datos={datosformulario}
        />
      ) : null}
      {notify && notify.open ? (
        <Notify
          mensaje={notify.mensaje}
          open={notify.open}
          color={notify.color}
          handleClose={handleClose}
          severity={notify.severity}
        />
      ) : null}
    </>
  );
}
